import { Navigate } from "react-router-dom";
import { getSessionUser } from "../services/sessionStorage";

function HomeIndexRedirect() {
  const u = getSessionUser();
  const isSystemAdmin = !!u?.roles?.includes("SYSTEM_ADMIN");

  return <Navigate to={isSystemAdmin ? "usuarios" : "eventos"} replace />;
}

export default HomeIndexRedirect;